import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'recruiter-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recruiter-profile.component.html',
  styleUrl: './recruiter-profile.component.css'
})
export class RecruiterProfileComponent implements OnInit{
  @Input() data:any
  @Input() config:any
  showJobDetails = false;
  showCompanyProfileDetails = false;

  ngOnInit(): void {
    if(typeof this.data==='string'){
      this.data=JSON.parse(this.data);
    }
    if(typeof this.config==='string'){
      this.config=JSON.parse(this.config);
    }
    console.log('recruiter-profile',this.data)
  }
  showJobs() {
    this.showJobDetails = true;
    this.showCompanyProfileDetails = false; // Hide company profile details if the Jobs button is clicked
  }

  showCompanyProfile() {
    this.showCompanyProfileDetails = true;
    this.showJobDetails = false; // Hide job details if the Company Profile button is clicked
  }

}
